import { useRef } from "react";

import { Box, Skeleton, Typography } from "@mui/material";
import { Layer, Map, Source } from "react-map-gl";
import {
  clusterCountLayer,
  clusterLayer,
  unclusteredPointLayer,
} from "./layers";

import { useLocations } from "@/services/data";
const MAPBOX_TOKEN =
  "pk.eyJ1IjoicGhsZXZlbDciLCJhIjoiY2x0NmRkbmc5MDN6MTJucDZueTVzd3J1bCJ9.LiVcmKEeOk_l5La0vFbcmQ";

export default function LocationsContainer() {
  const mapRef = useRef();

  const { data, isLoading } = useLocations();

  if (isLoading) {
    return <Skeleton variant="rectangular" height={350} />;
  }

  return (
    <Box id="map-content" sx={{ borderRadius: "25px", overflow: "hidden" }}>
      <style>
        {`.mapboxgl-control-container { display: none !important; }`}
      </style>

      {/* <Box sx={{ px: 2 }}>
        <Typography variant="h6">Locations</Typography>
      </Box> */}

      <Map
        initialViewState={{
          latitude: 40.67,
          longitude: -103.59,
          zoom: 0,
        }}
        style={{ height: 400 }}
        mapStyle="mapbox://styles/mapbox/dark-v9"
        mapboxAccessToken={MAPBOX_TOKEN}
        interactiveLayerIds={[clusterLayer.id]}
        // onClick={onClick}
        ref={mapRef}
      >
        <Source
          id="subscribers"
          type="geojson"
          // data="https://docs.mapbox.com/mapbox-gl-js/assets/earthquakes.geojson"
          data={{
            type: "FeatureCollection",
            features: data,
          }}
          cluster={true}
          clusterMaxZoom={14}
          clusterRadius={50}
        >
          <Layer {...clusterLayer} />
          <Layer {...clusterCountLayer} />
          <Layer {...unclusteredPointLayer} />
        </Source>
      </Map>
    </Box>
  );
}
